import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { EventService } from "src/app/core/services/event.service";
import { eventActions } from "./event.actions";

@Injectable()
export class EventEffects {

    private readonly action$ = inject(Actions);
    private readonly eventService = inject(EventService);

    loadEventFromApi$ = createEffect(() => {
        return this.action$.pipe(
            ofType(eventActions.loadEvent),
            switchMap((payload) => this.eventService.getEvents(payload.payload).pipe(
                map(eventResponse => eventActions.loadSuccess(eventResponse)),
                catchError((eventResponse) => of(eventActions.loadFailed(eventResponse)))
            ))
        )
    })

    loadEventById$ = createEffect(() => {
        return this.action$.pipe(
            ofType(eventActions.loadEventById),
            switchMap((payload) => this.eventService.getEventByID(payload.payload).pipe(
                map(eventResponse => eventActions.loadSuccessById(eventResponse)),
                catchError((eventResponse) => of(eventActions.loadFailedById(eventResponse)))
            ))
        )
    })

}